export const OnSessionStartedCodes = {
  AUTHENTICATION_SUCCESS: 1,
  AUTHENTICATION_FAILED: 2,
  NOT_AUTHENTICATED: 3,
};
